<template>
    <b-row>
        <b-col :cols="labelCols ? labelCols : 2">
            <label>
                {{ label }}
            </label>
        </b-col>
        <b-col v-if="isPure" :cols="cols" >
            <div class="static-input-value">
                {{ formattedValue }}
            </div>
        </b-col>
        <b-col :cols="cols*6" :sm="cols*4" :md="cols*2"	:lg="cols*2" :xl="cols" v-else>
            <div class="static-input-value">
                {{ formattedValue }}
            </div>
        </b-col>        
    </b-row>
</template>

<script>
  import PhoneFormatter from "../helpers/phone.formatter";

export default {
  name: "rdkm-static-text",
  props: ["cols", "value", "label", "type", "labelCols", "isPure"],
  computed: {
    formattedValue(val) {
      if (this.type === "phone") {
        return PhoneFormatter.format(this.value);
      } else {
        return this.value;
      }
    }
  }
};
</script>

